import React from 'react'

import { COLORS } from '../../../constants/colors'
import { IconProps } from '../../../types/types'

const ArrowRightIcon = ({ color = COLORS.white, size = 16 }: IconProps) => {
  return (
    <svg
      className='arrow-right'
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        transform={`scale(${size / 16})`}
        d='m5.429 13.143 4.937-4.991a.444.444 0 0 0-.003-.629l-4.934-4.88h0'
        stroke={color}
        strokeWidth='1.194'
        strokeLinecap='round'
        fill='none'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default ArrowRightIcon
